import { backend, BackendQueryKeys, useTypeSafeQuery } from '@oresundsbron/api';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

export function useEmissionClasses() {
  const { locale } = useRouter();
  const { t } = useTranslation(['common'], {
    nsMode: 'fallback',
  });

  const { data } = useTypeSafeQuery(
    BackendQueryKeys.ClimateList({ locale }),
    (req) => req.Climate.list(locale || ''),
    { staleTime: Infinity }
  );

  const fuelTypeHybridIDs = data?.fuelTypeHybridIDs || [];

  const fuelTypes = (data?.fuelTypes || []).map((fuelType) => ({
    label: t(`fuelTypes.${fuelType.key}`),
    value: fuelType.value,
    tariffClassification: fuelType.tariffClassification,
  }));

  const emissionClasses = (data?.emissionClasses || []).map((ec) => ({
    label: t(`emissionClasses.${ec.key}`),
    value: ec.value,
  }));

  const co2EmissionClasses = (data?.co2EmissionClasses || []).map(
    ({ key, value }) => ({
      label: t(`co2EmissionClass.${key}`),
      value,
    })
  );

  return {
    fuelTypes,
    fuelTypeHybridIDs,
    emissionClasses,
    co2EmissionClasses,
  };
}
